import React from 'react';
import Box from '@sizeid/commons/components/Box';
import Button from '@sizeid/commons/components/Button';
import { WithTranslation } from 'next-i18next';

import { CollapseToggleProps } from 'components/Collapse/types';
import { withTranslation } from 'lib/i18n';

const CollapseToggle: React.FC<CollapseToggleProps & WithTranslation> =
  props => (
    <Box display="block" paddingTop="40px">
      <Button large outline onClick={props.onClick}>
        {props.t(
          props.collapsed
            ? 'business.index.show_more'
            : 'business.index.show_less',
        )}
      </Button>
    </Box>
  );

export default withTranslation('pages')(CollapseToggle);
